import * as NotificationActions from '../actions/notification.action';

export interface State {
  message: string;
}
const initialState: State = {
  message: null,
};
export function reducer(
  state = initialState,
  action: NotificationActions.NotificationActions
) {
  switch (action.type) {
    case NotificationActions.CREATE_NOTIFICATION:
      return { ...state, message: action.payload };
    case NotificationActions.REMOVE_NOTIFICATION:
      return { ...state, message: null };
    default:
      return state;
  }
}
